import z from 'zod';

export const enumSchema = <T extends Record<string | number, string | number>>(
  enum_: T
) =>
  z.preprocess((val) => {
    // Coerce strings to numbers for numeric enums
    // TODO: use string enums only
    if (typeof val === 'string' && val in enum_) {
      return enum_[val as keyof T];
    }
    return val;
  }, z.enum(enum_));
